import { callFunction } from './functions';

/**
 * Submit a support request via the existing `submitSupportRequest` Cloud
 * Function (auth required; resolves the caller's identity server-side).
 */
export async function submitSupportRequest(
  message: string,
  firstName?: string,
  chat?: Array<{ role: string; content: string; isUser?: boolean }>,
): Promise<void> {
  await callFunction('submitSupportRequest', {
    ...(message ? { message } : {}),
    ...(firstName ? { firstName } : {}),
    ...(chat ? { chat } : {}),
  });
}
